import script from "./appSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./appSidebar.vue?vue&type=script&setup=true&lang=js"

import "./appSidebar.vue?vue&type=style&index=0&id=5b8163d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b8163d0"]])

export default __exports__